import { useSelector } from 'react-redux';

import { getAuthUser } from '../../../store/models/user/user.selectors';

export const Stats = (props) => {
  const statsProps = props.statsProps || {};
  const campaignId = props.campaign.id;
  const topic = statsProps.topic || '';
  const feedback = statsProps.feedback || '';

  const { token } = useSelector(getAuthUser);

  let url = `https://aggero-audience-insights-771165591077.europe-west1.run.app/Influencer_Profile?embedded=true&iframe=true&campaign_id=${campaignId}&token=${token}`;
  // let url = `https://aggero-audience-insights-seoul-771165591077.asia-northeast3.run.app/Influencer_Profile?embedded=true&iframe=true&campaign_id=${campaignId}&token=${token}`;

  if (topic !== '') {
    url += `&topic=${topic}`;
  }
  if (feedback !== '') {
    url += `&feedback=${feedback}`;
  }
  return (
    <div>
      <iframe
        src={url}
        height="auto"
        style={{ width: '100%', height: '100vh', border: 'none' }}
        title="streamlit"
      ></iframe>
    </div>
  );
};
